<template>
  <div>
    <Modal
      v-model="collectionAccountReviewModal"
      class-name="collectionAccountReviewStyle"
      width="700"
      :transfer="false"
      :mask-closable="false"
      :title="modalTitle"
      @on-visible-change="modalVisibleChange">

      <!-- 查看模式：只读展示原记录和变更后记录 -->
      <div v-if="operationType === 'look'" class="view_content_box">
        <div class="record_section">
          <h3 class="section_title">{{ $t('key1002710') }}</h3>
          <div class="record_item" v-if="originalRecordData">
            <p class="mt5 mb3">{{ $t('key1002702') }}{{ originalRecordData.payTypeName || '-' }}</p>
            <p class="mt3 mb3">{{ originalRecordData.accountLabel }}：{{ originalRecordData.payAccountNumber || '-' }}</p>
            <p class="mt3 mb3">{{ $t('key1002703') }}{{ originalRecordData.name || '-' }}</p>
          </div>
          <div class="record_item" v-else>
            <p class="mt5 mb3">{{ $t('key1002711') }}</p>
          </div>
        </div>
        <div class="record_section mt20">
          <h3 class="section_title">{{ $t('key1002712') }}</h3>
          <div class="record_item" v-if="changeRecordData">
            <p class="mt5 mb3">{{ $t('key1002702') }}{{ changeRecordData.payTypeName || '-' }}</p>
            <p class="mt3 mb3">{{ changeRecordData.accountLabel }}：{{ changeRecordData.payAccountNumber || '-' }}</p>
            <p class="mt3 mb3">{{ $t('key1002703') }}{{ changeRecordData.name || '-' }}</p>
          </div>
          <div class="record_item" v-else>
            <p class="mt5 mb3">{{ $t('key1002711') }}</p>
          </div>
        </div>
      </div>

      <!-- 编辑/审核模式：可编辑表单 -->
      <div v-if="operationType === 'edit' || operationType === 'audit'">
        <Form
          :model="collectionAccountForm"
          :disabled="operationType === 'audit'"
          ref="collectionAccountForm"
          :rules="ruleValidate"
          :label-width="120"
          @submit.native.prevent>
          <!--收款方式-->
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002702')" prop="payType" class="reset_form_item">
              <RadioGroup v-model="collectionAccountForm.payType" class="radioGroup_reset_style">
                <Radio :label="item.payType" v-for="(item, index) in payTypeList" :key="index">
                  <img :src="item.logoImg" width="130" :height="item.payType === 1 ? 47 : 43"
                    :class="item.payType === 1 ? 'mr20' : ''" alt=""/>
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <!--银行卡-->
          <Row style="width: 90%;" v-if="collectionAccountForm.payType === 1">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002703')" prop="name">
                <Input v-model.trim="collectionAccountForm.name" :placeholder="$t('key1002698')"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002704')" prop="issuingBank">
                <Input v-model.trim="collectionAccountForm.issuingBank" :placeholder="$t('key1002687')"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002705')" prop="payAccountNumber">
                <Input v-model.trim="collectionAccountForm.payAccountNumber" :placeholder="$t('key1002695')"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002706')" prop="idCard">
                <Input v-model.trim="collectionAccountForm.idCard" :placeholder="$t('key1002700')"></Input>
              </FormItem>
            </Col>
          </Row>
          <!--支付宝-->
          <Row style="width: 90%;" v-if="collectionAccountForm.payType === 2">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002707')" prop="payAccountNumber">
                <Input v-model.trim="collectionAccountForm.payAccountNumber"
                  :placeholder="$t('key1002708')"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002703')" prop="name">
                <Input v-model.trim="collectionAccountForm.name"
                  :placeholder="$t('key1002699')"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002709')" prop="idCard">
                <Input v-model.trim="collectionAccountForm.idCard"
                  :placeholder="$t('key1002701')"></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <template #footer>
        <template v-if="operationType === 'audit'">
          <Button type="error" ghost @click="rejectBtn"
            v-if="supplierDetails.updateSupplierPayAccountAuditStatus !== 0">{{ $t('key1002713') }}</Button>
          <Button type="primary" @click="approvedBtn">{{ $t('key1000986') }}</Button>
        </template>
        <template v-if="operationType === 'edit'">
          <Button @click="collectionAccountReviewModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="submitBtn">{{ $t('key1000555') }}</Button>
        </template>
        <template v-if="operationType === 'look'">
          <Button type="primary" @click="collectionAccountReviewModal = false">{{ $t('key1000248') }}</Button>
        </template>
      </template>
    </Modal>
    <!--驳回弹窗-->
    <rejectApplicationModal
      ref="rejectApplication"
      :toExamineStatus="6"
      :detailsData="supplierDetails"
      :ymsMerchantId="ymsMerchantId"
      @resetDetails="resetDetails"
      @rejectApplicationUpdateData="rejectApplicationUpdateData">
    </rejectApplicationModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import rejectApplicationModal from "@/views/yms/components/supplierManagement/rejectApplicationModal.vue";
import {getDataSetBatchList, getEnumName} from "@/utils/common";

export default {
  name: 'collectionAccountReviewModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      collectionAccountReviewModal: false,
      modalTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002686'),
      operationType: 'look', // 操作类型：audit(审核)、edit(编辑)、look(查看)
      ymsMerchantId: null,
      ymsPayAccountId: null,
      supplierDetails: {},
      detailsData: {},
      originalRecordData: null,
      changeRecordData: null,
      collectionAccountForm: {
        payType: 1, // 支付方式：1银行卡 2支付宝
        name: '', // 开户人姓名
        issuingBank: '', // 开户行
        payAccountNumber: '', // 银行卡号/支付宝账户
        idCard: '', // 身份证号
      },
      ruleValidate: {
        payAccountNumber: [
          {required: true, validator: v.validateEmailOrMobile(), trigger: 'blur'}
        ],
        name: [
          {required: true, validator: v.validateName(), trigger: 'blur'}
        ],
        idCard: [
          {required: true, validator: v.validateidCard(), trigger: 'blur'}
        ],
        issuingBank: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002687'), trigger: 'blur'}
        ]
      },
      payTypeList: [
        {
          payType: 1,
          logoImg: require('@/assets/images/pay/bankCard.png'),
        },
        {
          payType: 2,
          logoImg: require('@/assets/images/pay/alipay.png'),
        }
      ],
      enumData: [],
    };
  },
  methods: {
    // 初始化收款账户审核弹窗数据
    initCollectionAccountReviewData(type, data, value) {
      let v = this;
      v.operationType = type;
      v.ymsMerchantId = null;
      v.ymsPayAccountId = null;
      v.supplierDetails = {};
      v.originalRecordData = null;
      v.changeRecordData = null;
      if (!value) {
        v.detailsData = {};
      }

      // 设置标题
      let titleMap = {
        audit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002688'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002689'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002686'),
      };
      v.modalTitle = titleMap[type] || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002686');

      if (data) {
        v.detailsData = JSON.parse(JSON.stringify(data));
        v.ymsMerchantId = data.ymsMerchantId || null;
        v.ymsPayAccountId = data.ymsPayAccountId || null;

        // 解析原记录
        if (data.originalRecord) {
          let origObj = JSON.parse(data.originalRecord);
          v.originalRecordData = v.parseRecordData(origObj);
        }

        // 解析变更后记录
        if (data.changeRecord) {
          let changeObj = JSON.parse(data.changeRecord);
          v.changeRecordData = v.parseRecordData(changeObj);
        }
      }

      // 加载枚举数据
      (async () => {
        v.enumData = await getDataSetBatchList(['YmsPayAccountPayTypeSupplierEnum']);
        // 重新解析以获取枚举名称
        if (data) {
          if (data.originalRecord) {
            let origObj = JSON.parse(data.originalRecord);
            origObj.payTypeName = getEnumName(v.enumData, 'YmsPayAccountPayTypeSupplierEnum', origObj.payType) || origObj.payTypeName;
            v.originalRecordData = v.parseRecordData(origObj);
          }
          if (data.changeRecord) {
            let changeObj = JSON.parse(data.changeRecord);
            changeObj.payTypeName = getEnumName(v.enumData, 'YmsPayAccountPayTypeSupplierEnum', changeObj.payType) || changeObj.payTypeName;
            v.changeRecordData = v.parseRecordData(changeObj);
          }
        }
        v.$forceUpdate();
      })();

      // 获取供应商收款账户详情
      v.getPayAccountDetails(type);
    },
    // 获取供应商收款账户详情数据
    getPayAccountDetails(type) {
      let v = this;
      if (!v.ymsMerchantId) {
        v.collectionAccountReviewModal = true;
        return;
      }
      v.axios.get(api.get_ymsSupplierMerchant_queryPayAccount + v.ymsMerchantId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.supplierDetails = data;
            if (type !== 'look' && data.payType) {
              v.collectionAccountForm = {
                payType: data.payType || 1,
                name: data.name || '',
                issuingBank: data.payType === 1 ? (data.issuingBank || '') : '',
                payAccountNumber: data.payAccountNumber || '',
                idCard: data.idCard || '',
              };
              v.ymsPayAccountId = data.ymsPayAccountId || v.ymsPayAccountId;
            }
            v.collectionAccountReviewModal = true;
            v.$forceUpdate();
          }
          v.collectionAccountReviewModal = true;
        }
      });
    },
    // 解析记录数据，统一格式化
    parseRecordData(obj) {
      if (!obj) return null;
      let payTypeName = '';
      let accountLabel = '';
      if (obj.payType === 1) {
        payTypeName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002690');
        accountLabel = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002691');
      } else {
        payTypeName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002692');
        accountLabel = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002693');
      }
      // 如果有枚举名称则优先使用
      if (obj.payTypeName) {
        payTypeName = obj.payTypeName;
      }
      return {
        payType: obj.payType,
        payTypeName: payTypeName,
        accountLabel: accountLabel,
        payAccountNumber: obj.payAccountNumber || '-',
        name: obj.name || '-',
        issuingBank: obj.issuingBank || '',
        idCard: obj.idCard || '',
      };
    },
    // 编辑模式下的保存按钮
    submitBtn() {
      let v = this;
      v.$refs['collectionAccountForm'].validate((valid) => {
        if (valid) {
          let query = Object.assign({}, v.collectionAccountForm, {ymsPayAccountId: v.ymsPayAccountId});
          // 支付宝不需要开户行
          if (v.collectionAccountForm.payType === 2) {
            delete query.issuingBank;
          }
          query.supplierMerchantId = v.ymsMerchantId;
          query.updateSupplierPayAccountAuditStatus = v.supplierDetails.updateSupplierPayAccountAuditStatus;
          query.updateSupplierPayAccountAuditTime = v.$uDate.getCurrentTime('fulltime');
          v.axios.post(api.post_ymsSupplierMerchant_updateSupplierPayAccount, query, {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
              v.collectionAccountReviewModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 审核通过
    approvedBtn() {
      let v = this;
      let query = Object.assign({}, v.collectionAccountForm, {ymsPayAccountId: v.ymsPayAccountId});
      // 支付宝不需要开户行
      if (v.collectionAccountForm.payType === 2) {
        delete query.issuingBank;
      }
      query.supplierMerchantId = v.ymsMerchantId;
      query.updateSupplierPayAccountAuditStatus = 2;
      query.updateSupplierPayAccountAuditTime = v.$uDate.getCurrentTime('fulltime');
      v.axios.post(api.post_ymsSupplierMerchant_updateSupplierPayAccountAudit,
        query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002694'));
          v.collectionAccountReviewModal = false;
          v.$emit('updateData', true);
        }
      });
    },
    // 驳回按钮
    rejectBtn() {
      this.collectionAccountReviewModal = false;
      this.$refs['rejectApplication'].rejectApplicationModal = true;
    },
    // 重新获取详情数据
    resetDetails(val) {
      if (!val) {
        this.initCollectionAccountReviewData('audit', this.detailsData, true);
      }
    },
    // 驳回成功之后
    rejectApplicationUpdateData() {
      this.$refs['rejectApplication'].rejectApplicationTalg = false;
      this.$refs['rejectApplication'].rejectApplicationModal = false;
      this.collectionAccountReviewModal = false;
      this.$emit('updateData', true);
    },
    // 监听弹窗关闭
    modalVisibleChange(value) {
      if (!value) {
        this.$nextTick(() => {
          if (this.$refs['collectionAccountForm']) {
            this.$refs['collectionAccountForm'].resetFields();
          }
        });
        this.collectionAccountForm = {
          payType: 1,
          name: '',
          issuingBank: '',
          payAccountNumber: '',
          idCard: '',
        };
        this.originalRecordData = null;
        this.changeRecordData = null;
        this.ymsPayAccountId = null;
        this.enumData = [];
      }
    },
    // 校验手机号/邮箱
    validateEmailOrMobile() {
      let v = this;
      let isMob = v.$regular.isPhone;
      let isMailbox = v.$regular.isMailbox;
      return function (rule, value, callback) {
        let payType = v.collectionAccountForm.payType;
        if (payType === 1) {
          if (!value) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002695')));
          }
        } else {
          if (!value) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002696')));
          } else if (!(isMob.test(value) || isMailbox.test(value))) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002697')));
          } else {
            callback();
          }
        }
        callback();
      };
    },
    // 校验开户人姓名
    validateName() {
      let v = this;
      return function (rule, value, callback) {
        let payType = v.collectionAccountForm.payType;
        let text = payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002698') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002699');
        if (!value) {
          return callback(new Error(text));
        } else {
          callback();
        }
        callback();
      };
    },
    // 校验证件号
    validateidCard() {
      let v = this;
      return function (rule, value, callback) {
        let payType = v.collectionAccountForm.payType;
        let text = payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002700') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002701');
        if (!value) {
          return callback(new Error(text));
        } else {
          callback();
        }
        callback();
      };
    }
  },
  watch: {
    'collectionAccountForm.payType': {
      handler(value) {
        if (!this.$refs['collectionAccountForm']) return;
        let fieldlist = this.$refs['collectionAccountForm'].fields;
        let keyList = [];
        if (value === 1) {
          keyList = ['name', 'payAccountNumber', 'idCard'];
        } else {
          keyList = ['name', 'issuingBank', 'payAccountNumber', 'idCard'];
        }
        fieldlist.map((item) => {
          if (keyList.includes(item.prop)) {
            item.resetField();
            this.$forceUpdate();
          }
        });
      },
      deep: true
    }
  },
  components: {
    rejectApplicationModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .collectionAccountReviewStyle {

  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }

  .ivu-input {
    height: 35px;
    line-height: 35px;
  }

  .reset_form_item {
    .ivu-form-item-label {
      height: 40px;
      line-height: 40px;
      padding: 0;
    }
  }

  .radioGroup_reset_style {
    display: flex;

    label {
      display: flex;
      align-items: center;
    }

    .mr30 {
      margin-right: 30px;
    }
  }

  .view_content_box {
    padding: 10px 20px;

    .record_section {
      .section_title {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e8eaec;
      }

      .record_item {
        padding-left: 10px;

        p {
          font-size: 13px;
          color: #515a6e;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
